<template>
  <div>
    <script type="text/partytown">
        {{ script }}
    </script>
  </div>
</template>

<script>
export default {
  name: "MyPartytown",
  props: ['script']
}
</script>

<style>

</style>